import React from 'react';
import BodyText from '../Typography/BodyText/BodyText';
import Element, { CommonProps } from '../Element/Element';
import Flex from './../../components/Flex/Flex';
import Gutter from './../../components/Gutter/Gutter';
import Icon from './../Icon/Icon';
import styles from './FilterChip.module.scss';

type FilterChipsProps = {
  /** Chip text */
  text: string;
  /** Controls if disabled or not */
  disabled?: boolean;
  /** Onclick callback */
  onClick: () => void;
} & CommonProps<'button'>;

const FilterChip: React.FunctionComponent<FilterChipsProps> = ({
  text,
  disabled,
  onClick,
  ...props
}) => {
  const classNames = [styles.filterChip];

  disabled && classNames.push(styles.filterChip__disabled);

  return (
    <Element
      tagName="button"
      color="gray400"
      hoverColor="gray500"
      boxShadow="sm"
      onClick={onClick}
      borderRadius={{ size: 'sm' }}
      className={['filterChip-test', classNames]}
      padding={{ vertical: 'xs', horizontal: 'sm' }}
      backgroundColor={disabled ? 'gray200' : 'white'}
      {...props}
    >
      <Flex centered>
        <Icon name="close" size="xs" className={styles.filterChip__icon} />
        <Gutter size={'xs'} />
        <BodyText tagName="span" size={'sm'}>
          {text}
        </BodyText>
      </Flex>
    </Element>
  );
};

export default FilterChip;
